// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const CheckCircleIcon = /* @__PURE__ */ createIcon(
  'check-circle',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-5.207-3.707a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l2.293 2.293zM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11',
      },
    ],
  ]
);
